var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.5 11L11.5 13L16 8.5M12.4932 5.13581C10.4938 2.7984 7.15975 2.16964 4.65469 4.31001C2.14964 6.45038 1.79697 10.029 3.7642 12.5604C5.25009 14.4724 9.47129 18.311 11.448 20.0749C11.8114 20.3991 11.9931 20.5613 12.2058 20.6251C12.3905 20.6805 12.5958 20.6805 12.7805 20.6251C12.9932 20.5613 13.1749 20.3991 13.5383 20.0749C15.515 18.311 19.7362 14.4724 21.2221 12.5604C23.1893 10.029 22.8797 6.42787 20.3316 4.31001C17.7835 2.19216 14.4925 2.7984 12.4932 5.13581Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCheck);
export default __webpack_public_path__ + "static/media/heartCheck.31d4f82781798c0ec7edbb7b1d495b0e.svg";
export { ForwardRef as ReactComponent };